import KeyValuePair from '@/modules/core/support/KeyValuePair';

/**
 * Slot
 *
 * Posición de un menú en la página web
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
export default class Slot {
    public constructor (public key: string, public name = '') {}

    public static deserialize (data: KeyValuePair) {
        return new this(data.key, data.name || '')
    }
}
